import { render } from "./XIcon.vue?vue&type=template&id=972b9f6e&scoped=true"
import script from "./XIcon.vue?vue&type=script&lang=js"
export * from "./XIcon.vue?vue&type=script&lang=js"

import "./XIcon.vue?vue&type=style&index=0&id=972b9f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972b9f6e"]])

export default __exports__